import { BookOpen, CalendarDays, Clock, UsersRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { StatCard } from '@/components/ui/StatCard'
import type { WeekData } from '../types'

/** Totals for a teacher's week: periods, sections, subjects and teaching days. */
export function WeekSummary({ week }: { week: WeekData }) {
  const { t } = useTranslation('timetable')
  const sections = new Set(week.entries.map((e) => e.section.id)).size
  const subjects = new Set(week.entries.map((e) => e.subject.id)).size
  const days = new Set(week.entries.map((e) => e.dayOfWeek)).size
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4 print:hidden">
      <StatCard label={t('Periods a week')} value={week.totalPeriods} icon={<Clock />} />
      <StatCard label={t('Sections')} value={sections} icon={<UsersRound />} tone="violet" />
      <StatCard label={t('Subjects')} value={subjects} icon={<BookOpen />} tone="info" />
      <StatCard label={t('Teaching days')} value={days} icon={<CalendarDays />} tone="success" />
    </div>
  )
}
